const homeTutorService = {
  title: "Home Tutor",
  icon: "📚",
  rateCardKey: "home-tutor",
  shortDescription:
    "Academic tutoring, subject support, homework help, and home learning sessions.",
  longDescription:
    "Book tutor support for school subjects, homework help, concept strengthening, and regular home teaching sessions.",
  consultationNote:
    "Board exam prep, advanced competitive prep, or language specialization should be priced after subject and class assessment.",
  responsePromise:
    "Assignment depends on class level, subject, location, and tutor availability.",
  warrantyPolicy:
    "Learning outcomes depend on student consistency, session frequency, and curriculum scope.",
  subServices: [
    {
      id: "tutor-primary-session",
      title: "Primary Level Home Tutoring",
      icon: "📝",
      group: "School Tutoring",
      description:
        "Basic concept and homework support for primary grade students.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "1 hr",
      warranty: "Session completion only",
      unit: "session",
    },
    {
      id: "tutor-secondary-session",
      title: "Secondary Level Home Tutoring",
      icon: "📖",
      group: "School Tutoring",
      description:
        "Subject tutoring for middle and secondary school level.",
      basePrice: 499,
      priceType: "starts_at",
      duration: "1 hr",
      warranty: "Session completion only",
      unit: "session",
    },
    {
      id: "tutor-monthly-plan",
      title: "Monthly Home Tutor Plan",
      icon: "📅",
      group: "Recurring",
      description:
        "Recurring home tuition plan depending on class, subject, and number of sessions.",
      basePrice: 2499,
      priceType: "starts_at",
      duration: "Monthly plan",
      warranty: "Attendance/support policy",
      unit: "month",
    },
    {
      id: "tutor-subject-consult",
      title: "Tutor Requirement Consultation",
      icon: "🎓",
      group: "Consultation",
      description:
        "Consultation for subject matching, student level, and tutor requirement planning.",
      basePrice: 199,
      priceType: "inspection",
      duration: "20-30 mins",
      warranty: "Consultation only",
      unit: "consult",
    },
  ],
};

export default homeTutorService;